import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OutrasReceitasEditarComponent } from './outras-receitas-editar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: OutrasReceitasEditarComponent }
    ])],
    exports: [RouterModule]
})
export class OutrasReceitasEditarRoutingModule { }
